import { render, staticRenderFns } from "./4.vue?vue&type=template&id=b6a40cec&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=b6a40cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a40cec",
  null
  
)

export default component.exports